import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决路由重复问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const Home = () => import('../views/Home.vue')
const Index = () => import('../views/Index.vue')
const About = () => import('../views/About.vue')
const Member = () => import('../views/Member.vue')
const News = () => import('../views/News.vue')
// const Library = () => import('../views/Library.vue')
// const Branch = () => import('../views/Branch.vue')
const Contact = () => import('../views/Contact.vue')
const Details = () => import('../views/Details.vue')
const Certification = () => import('../views/Certification.vue')
const Work = () => import('../views/Work.vue')
const Brand = () => import('../views/Brand.vue')
const Books = () => import('../views/Books.vue')
const Specifics = () => import('../views/Specifics.vue')
const Answer = () => import('../views/Answer.vue')
const HomeEn = () => import('../views_en/HomeEn.vue')
const IndexEn = () => import('../views_en/IndexEn.vue')
const AboutEn = () => import('../views_en/AboutEn.vue')
const MemberEn = () => import('../views_en/MemberEn.vue')
const NewsEn = () => import('../views_en/NewsEn.vue')
// const LibraryEn = () => import('../views_en/LibraryEn.vue')
// const BranchEn = () => import('../views_en/BranchEn.vue')
const ContactEn = () => import('../views_en/ContactEn.vue')
const DetailsEn = () => import('../views_en/DetailsEn.vue')
const WorkEn = () => import('../views_en/WorkEn.vue')
const CertificationEn = () => import('../views_en/CertificationEn.vue')
const BrandEn = () => import('../views_en/BrandEn.vue')
const BooksEn = () => import('../views_en/BooksEn.vue')
const SpecificsEn = () => import('../views_en/SpecificsEn.vue')
const AnswerEn = () => import('../views_en/AnswerEn.vue')

const ConferenceHome = () => import('../conference/ConferenceHome.vue')
const ConferenceIndex = () => import('../conference/ConferenceIndex.vue')
const ConferenceList = () => import('../conference/ConferenceList.vue')
const ConferenceDetails = () => import('../conference/ConferenceDetails.vue')
// const ConferenceHomeEn = () => import('../conference_en/ConferenceHomeEn.vue')
// const ConferenceIndexEn = () => import('../conference_en/ConferenceIndexEn.vue')
// const ConferenceListEn = () => import('../conference_en/ConferenceListEn.vue')
// const ConferenceDetailsEn = () => import('../conference_en/ConferenceDetailsEn.vue')
import Error from '../views/Error.vue'

Vue.use(VueRouter)

const routes = [
    // 主站页面
    {
        name: 'home',
        path: '/',
        component: Home,
        redirect: '/index',
        children: [
            {
                name: 'index',
                path: '/index',
                component: Index,
                meta: { title: '国家动物健康与食品安全创新联盟' }
            },
            {
                name: 'about',
                path: '/about',
                component: About,
                meta: { title: '关于联盟' }
            },
            {
                name: 'member',
                path: '/member',
                component: Member,
                meta: { title: '成员单位' }
            },
            {
                name: 'news',
                path: '/news',
                component: News,
                meta: { title: '新闻动态' }
            },
            // {
            //     name: 'library',
            //     path: '/library',
            //     component: Library,
            //     meta: { title: '联盟智库' }
            // },
            // {
            //     name: 'branch',
            //     path: '/branch',
            //     component: Branch,
            //     meta: { title: '分支机构' }
            // },
            {
                name: 'contact',
                path: '/contact',
                component: Contact,
                meta: { title: '联系我们' }
            },
            {
                name: 'details',
                path: '/details/:name/:type/:id/:current',
                component: Details,
                meta: { title: '详情' }
            },
            {
                name: 'certification',
                path: '/certification',
                component: Certification,
                meta: { title: '标准认证' }
            },
            {
                name: 'work',
                path: '/work',
                component: Work,
                meta: { title: '党建工作' }
            },
            {
                name: 'brand',
                path: '/brand',
                component: Brand,
                meta: { title: '品牌活动' }
            },
            {
                name: 'books',
                path: '/books',
                component: Books,
                meta: { title: '联盟出版书籍' }
            },
            {
                name: 'specifics',
                path: '/specifics/:name/:type/:id/:current',
                component: Specifics,
                meta: { title: '详情' }
            },
            {
                name: 'answer',
                path: '/answer',
                component: Answer,
                meta: { title: '你问我答' }
            },
        ]
    },
    // 主站英文页面
    {
        name: 'home_en',
        path: '/home_en',
        component: HomeEn,
        redirect: '/index_en',
        children: [
            {
                name: 'index_en',
                path: '/index_en',
                component: IndexEn,
                meta: { title: 'National animal health and Food Safety Innovation Alliance' }
            },
            {
                name: 'about_en',
                path: '/about_en',
                component: AboutEn,
                meta: { title: 'About Us' }
            },
            {
                name: 'member_en',
                path: '/member_en',
                component: MemberEn,
                meta: { title: 'Member Area' }
            },
            {
                name: 'news_en',
                path: '/news_en',
                component: NewsEn,
                meta: { title: 'News' }
            },
            // {
            //     name: 'library_en',
            //     path: '/library_en',
            //     component: LibraryEn,
            //     meta: { title: 'Alliance think tank' }
            // },
            // {
            //     name: 'branch_en',
            //     path: '/branch_en',
            //     component: BranchEn,
            //     meta: { title: 'Affiliated Agency' }
            // },
            {
                name: 'contact_en',
                path: '/contact_en',
                component: ContactEn,
                meta: { title: 'Contact Us' }
            },
            {
                name: 'details_en',
                path: '/details_en/:name/:type/:id/:current',
                component: DetailsEn,
                meta: { title: 'Details' }
            },
            {
                name: 'certification_en',
                path: '/certification_en',
                component: CertificationEn,
                meta: { title: 'Standard Certification' }
            },
            {
                name: 'work_en',
                path: '/work_en',
                component: WorkEn,
                meta: { title: 'Party Building Work' }
            },
            {
                name: 'brand_en',
                path: '/brand_en',
                component: BrandEn,
                meta: { title: 'Brand Event' }
            },
            {
                name: 'books_en',
                path: '/books_en',
                component: BooksEn,
                meta: { title: 'The Alliance Publishes Books' }
            },
            {
                name: 'specifics_en',
                path: '/specifics_en/:name/:type/:id/:current',
                component: SpecificsEn,
                meta: { title: 'Details' }
            },
            {
                name: 'answer_en',
                path: '/answer_en',
                component: AnswerEn,
                meta: { title: 'Question and Response' }
            },
        ]
    },
    // 大会页面
    {
        name: 'conference',
        path: '/conference',
        component: ConferenceHome,
        redirect: '/conference/index',
        children: [
            {
                name: 'confernece_index',
                path: '/conference/index',
                component: ConferenceIndex,
                meta: { title: '第六届中国动物健康与食品安全大会' }
            },
            {
                name: 'confernece_list',
                path: '/conference/list/:type/:category/:current',
                component: ConferenceList,
                meta: { title: '文章列表' }
            },
            {
                name: 'confernece_details',
                path: '/conference/details/:name/:type/:category/:id/:current',
                component: ConferenceDetails,
                meta: { title: '文章详情' }
            }
        ]
    },
    // {
    //     name: 'conference_en',
    //     path: '/conference_en',
    //     component: ConferenceHomeEn,
    //     redirect: '/conference/index_en',
    //     children: [
    //         {
    //             name: 'confernece_index_en',
    //             path: '/conference/index_en',
    //             component: ConferenceIndexEn,
    //             meta: { title: '第六届中国动物健康与食品安全大会' }
    //         },
    //         {
    //             name: 'confernece_list_en',
    //             path: '/conference/list_en/:type/:category/:current',
    //             component: ConferenceListEn,
    //             meta: { title: 'Article List' }
    //         },
    //         {
    //             name: 'confernece_details_en',
    //             path: '/conference/details_en/:name/:type/:category/:id/:current',
    //             component: ConferenceDetailsEn,
    //             meta: { title: 'Details' }
    //         }
    //     ]
    // },
    { name: 'error', path: '*', component: Error }
]

const router = new VueRouter({
    routes,
    linkActiveClass: 'router_active'
})

export default router
